import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteFill = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.2 5.99999H16.72C16.3373 4.25518 14.7001 3.00225 12.8 3H11.2C9.29988 3.00225 7.66271 4.25518 7.27998 5.99999H4.79999C4.35816 5.99999 4 6.33577 4 6.74998C4 7.16419 4.35816 7.5 4.79999 7.5H5.59998V17.25C5.60264 19.32 7.39196 20.9975 9.6 21H14.4C16.608 20.9975 18.3974 19.32 18.4 17.25V7.5H19.2C19.6418 7.5 20 7.16422 20 6.75001C20 6.3358 19.6418 5.99999 19.2 5.99999ZM11.2 15.75C11.2 16.1642 10.8418 16.5 10.4 16.5C9.95816 16.5 9.6 16.1642 9.6 15.75V11.25C9.6 10.8358 9.95816 10.5 10.4 10.5C10.8418 10.5 11.2 10.8358 11.2 11.25V15.75H11.2ZM14.4 15.75C14.4 16.1642 14.0418 16.5 13.6 16.5C13.1582 16.5 12.8 16.1642 12.8 15.75V11.25C12.8 10.8358 13.1582 10.5 13.6 10.5C14.0418 10.5 14.4 10.8358 14.4 11.25V15.75ZM8.93681 5.99999C9.27708 5.10171 10.1832 4.50114 11.2 4.49998H12.8C13.8168 4.50114 14.723 5.10171 15.0632 5.99999H8.93681Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgDeleteFill);
export default ForwardRef;
